const extractEstateKeys = estate => {
  const city = estate ? estate.city : ''
  const rooms =
    estate &&
    estate.features &&
    estate.features[0].amount > 0 &&
    `${estate.features[0].amount}-Quartos`

  return { city, rooms }
}

const parseUrl = url => {
  return url
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ /g, '-')
}

export const setListPropertySlug = estate => {
  const { city, rooms } = extractEstateKeys(estate)

  const url = rooms
    ? `${city}/${rooms}/${estate.propertySmallId}`
    : `${city}/${estate.propertySmallId}`

  return parseUrl(url)
}

export const setPropertySlug = (estate, id) => {
  const { city, rooms } = extractEstateKeys(estate)

  const url = rooms ? `${city}/${rooms}/${id}` : `${city}/${id}`

  return parseUrl(url)
}

export default setPropertySlug
